import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BaseMiscApiService } from '@common/api/base-misc-api.service';
import { AppConstants } from '@apps/app.constants';
import { CopilApi } from './models/copil-api';
import { CopilsSummaryApi } from '@apps/dash/api/models/copils-summary-api';

@Injectable({
    providedIn: 'root'
})
export class CopilsMiscApiService extends BaseMiscApiService
{
    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlDafa;
        this.segmentApi = '/dafa/copils';
    }

    getCopilsByEntityShortId (entityErpShortId: string): Observable<CopilApi[]>
    {
        //TODO d'où sort ce '\r' ?
        return this.get(`/${entityErpShortId.trim()}`);
    }

    getAllCopils (): Observable<CopilApi[]>
    {
        return this.get('/all');
    }

    getCopilsSummaryByEntityShortId (entityErpShortId: string): Observable<CopilsSummaryApi>
    {
        //TODO d'où sort ce '\r' ?
        return this.get(`/${entityErpShortId.trim()}/summary`);
    }
}
